/* tslint:disable */
/* eslint-disable */
export enum TickerStreamingMode {
  None = 'none',
  AudioOnly = 'audio_only',
  Video = 'video'
}
